import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"

const IconMigration = ({
  title = "Migration",
  viewBoxWidth = 64,
  viewBoxHeight = 64,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <svg width="64" height="64" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <circle fill="#F77769" cx="32" cy="32" r="32" />
        <path
          d="M24 20a2 2 0 012 2v20a2 2 0 01-2 2h-6a2 2 0 01-2-2V22a2 2 0 012-2h6zm22 0a2 2 0 012 2v20a2 2 0 01-2 2h-6a2 2 0 01-2-2V22a2 2 0 012-2h6zm-22 2h-6v20h6V22zm22 0h-6v20h6V22zm-15.5 5l5 5-5 5-1.5-1.5 3.5-3.5-3.5-3.5 1.5-1.5z"
          fill="#FFF"
          fillRule="nonzero"
        />
      </g>
    </svg>
  </Svg.Icon>
)

export default IconMigration
